import {url} from "./urls";

export const redirectToPubPortalClassic = () => {
    window.open(`https://publisher.${url.baseURL}`, '_self')
}
